import { useState } from 'react'
import { Form } from 'react-bootstrap'
import { useFormik } from 'formik'
import { Siren } from 'lucide-react'
import Swal from 'sweetalert2'
import { TextArea, MultiFile } from 'components/input_fields'
import { GuardSosSchema } from './ValidationSchema'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { sendGuardSos } from '../../../../redux/slices/help_desk'
import { toggleGuardSosModal } from '../../../../redux/slices/globalSlice'
import { addUpdateHandler } from 'utils'
import { useTranslation } from 'react-i18next'

const TICKET_FILE_ACCEPT = 'image/*,video/*'

export default function GuardSosForm({ categoryId }) {

    const [spinner, setSpinner] = useState(false)
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const initialValues = {
        complaint_category_id: categoryId,
        description: '',
        ticket_file: [],
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues,
        validationSchema: GuardSosSchema,
        enableReinitialize: true,
        onSubmit: async (vals, action) => {
            const result = await Swal.fire({
                title: t('sos.confirm_sos_title'),
                text: t('sos.confirm_sos_text'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#dc2626',
                cancelButtonColor: '#64748b',
                cancelButtonText: t('common.cancel'),
                confirmButtonText: t('sos.send_sos'),
                allowOutsideClick: false,
            })

            if (!result.isConfirmed) return

            setSpinner(true)
            dispatch(sendGuardSos({ values: vals })).then((res) => addUpdateHandler({
                res: res.payload,
                action,
                navigate,
                success_toast: res.payload.data.message,
                wrong_toast: t('sos.error_sos'),
                navigate_route: '',
                spinner: setSpinner,
                toggle: () => dispatch(toggleGuardSosModal()),
            }))
        },
    })

    return (
        <div className="sos-tab-content">
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>
                <div className="row g-2">

                    <div className="col-md-12">
                        <MultiFile
                            label_name={t('sos.ticket_file')}
                            mandatory={false}
                            name="ticket_file"
                            accept={TICKET_FILE_ACCEPT}
                            onChange={(e) => setFieldValue('ticket_file', Array.from(e.currentTarget.files).slice(0, 10))}
                            onBlur={handleBlur}
                            error={errors.ticket_file && touched.ticket_file ? <span className="field_error">{errors.ticket_file}</span> : null}
                        />
                    </div>

                    <div className="col-md-12">
                        <TextArea
                            label_name={t('sos.sos_description')}
                            mandatory={true}
                            placeholder=""
                            rows={3}
                            name="description"
                            value={values.description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.description && touched.description ? <span className="field_error">{errors.description}</span> : null}
                        />
                    </div>

                    <div className="col-md-12">
                        <button
                            type="submit"
                            className="sos-send-btn"
                            disabled={spinner}
                        >
                            <Siren size={22} />
                            {spinner ? t('sos.sending_sos') : t('sos.send_sos')}
                        </button>
                    </div>
                </div>
            </Form>
        </div>
    )
}
